import { useIntersectionObserver } from '@react-hookz/web';
import { ArrowBLeftIcon } from '@ubie/ubie-icons';
import clsx from 'clsx';
import { useRouter } from 'next/router';
import { FC, useCallback, useRef } from 'react';
import styles from './style.module.css';

export const Header: FC = () => {
  const router = useRouter();

  const ref = useRef<HTMLDivElement>(null);
  const intersection = useIntersectionObserver(ref, {
    root: null,
    rootMargin: '0px',
    threshold: [1],
  });

  const onClickBackButton = useCallback(() => {
    router.back();
  }, [router]);

  return (
    <>
      <div ref={ref} className={styles.intersectionObserver} />
      <header
        className={clsx(styles.root, {
          [styles.shadow]: intersection && !intersection?.isIntersecting,
        })}
      >
        <div>
          <button className={styles.backButton} onClick={onClickBackButton}>
            <ArrowBLeftIcon />
            <span>前に戻る</span>
          </button>
        </div>
      </header>
    </>
  );
};
